import { COMMON_FILTER_FIELD_IDS } from '../../reports-components/shared-filter-fields';

export const USAGE_REPORT_V2_FILTER_FIELD_IDS = Object.freeze({
  CustomerId: COMMON_FILTER_FIELD_IDS.Customer,
  Plan: COMMON_FILTER_FIELD_IDS.Plan,
  ContractStatus: 'contractStatus',
  PricingType: 'pricingType',
});
